import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { Component } from 'react';

function hasArrayChanged(a = [], b = []) {
  return a.length !== b.length || a.some((item, index) => !Object.is(item, b[index]));
}
const initialState = {
  didCatch: false,
  error: null
};
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
    this.state = initialState;
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      didCatch
    } = this.state;
    const {
      resetKey,
      onReset
    } = this.props;
    if (didCatch && prevState.error !== null && hasArrayChanged(prevProps.resetKey, resetKey)) {
      onReset === null || onReset === void 0 || onReset({
        next: resetKey,
        prev: prevProps.resetKey,
        reason: 'keys'
      });
      this.setState(initialState);
    }
  }
  componentDidCatch(error, info) {
    const {
      onError
    } = this.props;
    onError === null || onError === void 0 || onError(error, info);
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return {
      didCatch: true,
      error
    };
  }
  resetErrorBoundary(...args) {
    const {
      error
    } = this.state;
    const {
      onReset
    } = this.props;
    if (error !== null) {
      onReset === null || onReset === void 0 || onReset({
        args,
        reason: 'reset error'
      });
      this.setState(initialState);
    }
  }
  render() {
    const {
      error
    } = this.state;
    if (error) {
      return /*#__PURE__*/React__default.createElement("div", null, error.message);
    }
    const {
      children
    } = this.props;
    return children;
  }
}

// eslint-disable-next-line react/static-property-placement
_defineProperty(ErrorBoundary, "defaultProps", void 0);
ErrorBoundary.defaultProps = {
  children: undefined,
  onError: undefined,
  onReset: undefined,
  resetKey: undefined
};

export { ErrorBoundary as E };
//# sourceMappingURL=ErrorBoundary-gqZfKZVm.js.map
